<eaglei-user-report *ngIf="isManager" [isManagement]="true"></eaglei-user-report>
